/** Buyer UI copy for «Старт» — avoid promising market / platform RFQ. */
export const startPlanUiCopy = {
  cartEmptyDescription:
    'На тарифе «Старт» добавляйте позиции в «Мои прайсы» и формируйте бланк заказа для отправки поставщику.',
  cartEmptyActionLabel: 'Перейти в «Мои прайсы»',
  cartRegisteredHint: 'Позиции от поставщиков на платформе — доступны на тарифах «Стандарт» и «Премиум».',
  ordersEmptyDescription:
    'На тарифе «Старт» заявки поставщикам на платформе недоступны. Работайте через «Мои прайсы» и бланк заказа.',
  ordersEmptyPrimaryAction: { label: 'Мои прайсы', to: '/my-prices' as const },
  ordersEmptySecondaryAction: { label: 'Корзина', to: '/cart' as const, variant: 'ghost' as const },
  suppliersEmptyDescription:
    'На тарифе «Старт» список платформенных поставщиков недоступен. Ведите прайсы в разделе «Мои прайсы».',
  suppliersEmptyActionLabel: 'Открыть «Мои прайсы»',
  overviewRecentRfqsEmpty: 'На «Старте» заявки на платформе недоступны. Начните с «Моих прайсов» или корзины.',
  overviewSuppliersEmpty: 'На «Старте» платформенные поставщики недоступны. Добавьте прайсы в «Мои прайсы».',
  overviewCartHint: 'Позиции в корзине — оформите бланк заказа для поставщиков «вне системы».',
  overviewCartActionLabel: 'Открыть корзину',
  rfqCreateBlockedDescription:
    'Заявки поставщикам на платформе доступны на тарифах «Стандарт» и «Премиум». На «Старте» используйте «Мои прайсы» и бланк заказа.',
} as const

export const standardPlanUiCopy = {
  cartEmptyDescription: 'Выберите товары в каталоге — они появятся здесь, и вы сможете отправить заявки поставщикам.',
  cartEmptyActionLabel: 'Перейти в каталог',
  cartRegisteredHint: 'Позиции от поставщиков на платформе — можно отправить заявку.',
  ordersEmptyDescription: 'Добавьте позиции в корзину из каталога и отправьте заявку поставщикам.',
  suppliersEmptyDescription: 'Они появятся после первой заявки или когда вы добавите позиции из каталога.',
  suppliersEmptyActionLabel: 'Открыть каталог',
  overviewRecentRfqsEmpty: 'Активных заявок пока нет. Начните с каталога или корзины.',
  overviewSuppliersEmpty: 'Поставщики появятся после первой заявки. Пока можно выбрать позиции в каталоге.',
  overviewCartHint: 'Оформите заявку и отправьте поставщикам.',
  overviewCartActionLabel: 'Сформировать заявку',
} as const
